var render, staticRenderFns
import script from "./bar-chart-month2.vue?vue&type=script&lang=js"
export * from "./bar-chart-month2.vue?vue&type=script&lang=js"
import style0 from "./bar-chart-month2.vue?vue&type=style&index=0&id=59107e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59107e9c",
  null
  
)

export default component.exports